import * as React from 'react';
import { area as d3Area } from 'd3-shape';
import * as platform from 'platform';
import { ValueMappers, Scales } from '../../types';

import './index.scss';

interface Props {
  data: any[];
  scales: Scales;
  values: ValueMappers;
  areaBase?: number;
  withGradient?: boolean;
}

class Curve extends React.Component<Props> {
  render() {
    const { data, scales, values, areaBase, withGradient } = this.props;

    const area = d3Area()
      .x((d, i) => scales.x(values.x(d, i)))
      .y0(scales.y(areaBase || 0))
      .y1((d, i) => scales.y(values.y(d, i)));

    const line = d3Area()
      .x((d, i) => scales.x(values.x(d, i)))
      .y((d, i) => scales.y(values.y(d, i)));

    return (
      <g>
        <path className="chart-curve__area" d={area(data) || undefined} filter={this.getFilter()} />
        {withGradient && <path className="chart-curve__line" d={line(data) || undefined} />}
      </g>
    );
  }

  private getFilter() {
    const { withGradient } = this.props;

    if (platform.product === 'iPhone' || !withGradient) {
      return; //fallback to fill attr
    }

    const url = typeof window === 'undefined' ? '' : window.location.href;

    //https://stackoverflow.com/questions/20330149/svg-filter-only-working-when-added-in-style-attribute-firefox/20330581#20330581
    return `url(${url}#inner-shadow)`;
  }
}

export default Curve;
